import { storageAdapter } from "@/services/storageAdapter";
import videos from "@/data/videos.json";
import pdfs from "@/data/pdfs.json";

export const initialState = {
  isPwaModeActive: false,
  wasOfflineModeInitialized: storageAdapter("offlineModeWasInitialized").get(),
  isSettingsModalopen: false,
  language: "en",
  failedCache: false,
  isCachingElements: false,
  isCheckingCachedElements: false,
  isDeletingElements: false,
  deletedElements: 0,
  sumElementsToDelete: 0,
  loadedElements: 0,
  sumElementsToLoad: 0,
  enIsCached: false,
  deIsCached: false,
  supportsPWAandFetch: false,
  isSarsModalVisible: true,
  videos: { ...videos },
  pdfs: { ...pdfs }
};
